/* eslint-disable no-console */
import getCLinkerValue from './getCLinkerValue';

/**
 * Adds CLinker (_cl) parameter to a URL for cross-domain tracking
 *
 * Only adds _cl as the first query parameter without affecting the position
 * of hash fragments or other URL parts. Hash fragments stay in their exact position.
 *
 * @param {string} url - The URL to modify
 * @returns {string} URL with _cl parameter added as first query param, or original URL if no CLinker
 */
const addCLinkerToUrl = (url) => {
    if (!url || typeof url !== 'string') {
        return url;
    }

    // Get CLinker value
    const cLinker = getCLinkerValue();

    // If no CLinker (user opted out), return original URL
    if (!cLinker) {
        return url;
    }

    try {
        // Split URL into parts to handle hash fragments manually
        const hashIndex = url.indexOf('#');
        const baseUrl = hashIndex !== -1 ? url.substring(0, hashIndex) : url;
        const hashFragment = hashIndex !== -1 ? url.substring(hashIndex) : '';

        const urlObj = new URL(baseUrl);

        // Check if _cl parameter already exists
        if (urlObj.searchParams.has('_cl')) {
            // Update existing _cl parameter and keep it as first
            urlObj.searchParams.delete('_cl');
        }

        // Get all existing parameters
        const existingParams = [];
        urlObj.searchParams.forEach((value, key) => {
            existingParams.push([key, value]);
        });

        // Clear search params and rebuild with _cl first
        urlObj.search = '';
        urlObj.searchParams.set('_cl', cLinker);

        // Add back all existing parameters
        existingParams.forEach(([key, value]) => {
            urlObj.searchParams.set(key, value);
        });

        // Return URL with hash fragment in its original position
        return urlObj.toString() + hashFragment;
    } catch (error) {
        console.error('addCLinkerToUrl: Error processing URL:', url, error);
        // Fallback for malformed URLs - return original URL
        return url;
    }
};

export default addCLinkerToUrl;
